export enum MicroFrontendApp {
  LegacyVueApp = '@tangocard/rewards-genius',
  PortalContent = '@tangocard/portal',
  SideNav = '@tangocard/portal-side-nav',
}
